import { useState, useEffect } from "react";
import { editEducation, getOne } from "../../../../lib/hire";
import { ToastContainer, toast } from "react-toastify";

import addForm from "../../../../images/add-form.png";
import deleteForm from "../../../../images/delete-form.png";
import loader from "../../../../images/gif/loader.gif";


function Education ({userId}) {
    const [form1, setForm1] = useState(true);
    const [form2, setForm2] = useState(false);
    const [form3, setForm3] = useState(false);
    const [form4, setForm4] = useState(false);
    const [form5, setForm5] = useState(false);
    const [education1, setEducation1] = useState({});
    const [education2, setEducation2] = useState({});
    const [education3, setEducation3] = useState({});
    const [education4, setEducation4] = useState({});
    const [education5, setEducation5] = useState({});
    const [details1, setDetails1] = useState({
        institution:"",
        course:"",
        qualification:"",
        startMonth:"",
        endMonth:"",
        startYear:"",
        endYear:""
    })
    const [details2, setDetails2] = useState({
        institution:"",
        course:"",
        qualification:"",
        startMonth:"",
        endMonth:"",
        startYear:"",
        endYear:""
    });
    const [details3, setDetails3] = useState({
        institution:"",
        course:"",
        qualification:"",
        startMonth:"",
        endMonth:"",
        startYear:"",
        endYear:""
    });
    const [details4, setDetails4] = useState({
        institution:"",
        course:"",
        qualification:"",
        startMonth:"",
        endMonth:"",
        startYear:"",
        endYear:""
    });
    const [details5, setDetails5] = useState({
        institution:"",
        course:"",
        qualification:"",
        startMonth:"",
        endMonth:"",
        startYear:"",
        endYear:""
    });

    useEffect(()=>{
        getOne(userId)
            .then(response => response.data)
            .then(resp=>{
                console.log(resp);
                const { length } = resp.profile.education;
                if (length===1){
                    // setForm1(true);  --- alraedy true
                    setEducation1(resp.profile.education[0])
                    setDetails1(resp.profile.education[0])
                }else if (length===2){
                    setForm2(true);
                    setEducation1(resp.profile.education[0])
                    setDetails1(resp.profile.education[0])
                    setEducation2(resp.profile.education[1])
                    setDetails2(resp.profile.education[1])
                }else if (length===3){
                    setForm2(true);
                    setForm3(true);
                    setEducation1(resp.profile.education[0])
                    setDetails1(resp.profile.education[0])
                    setEducation2(resp.profile.education[1])
                    setDetails2(resp.profile.education[1])
                    setEducation3(resp.profile.education[2])
                    setDetails3(resp.profile.education[2])
                }else if (length===4){
                    setForm2(true);
                    setForm3(true);
                    setForm4(true);
                    setEducation1(resp.profile.education[0])
                    setDetails1(resp.profile.education[0])
                    setEducation2(resp.profile.education[1])
                    setDetails2(resp.profile.education[1])
                    setEducation3(resp.profile.education[2])
                    setDetails3(resp.profile.education[2])
                    setEducation4(resp.profile.education[3])
                    setDetails4(resp.profile.education[3])
                } else {
                    setForm2(true);
                    setForm3(true);
                    setForm4(true);
                    setForm5(true);
                    setEducation1(resp.profile.education[0])
                    setDetails1(resp.profile.education[0])
                    setEducation2(resp.profile.education[1])
                    setDetails2(resp.profile.education[1])
                    setEducation3(resp.profile.education[2])
                    setDetails3(resp.profile.education[2])
                    setEducation4(resp.profile.education[3])
                    setDetails4(resp.profile.education[3])
                    setEducation5(resp.profile.education[4])
                    setDetails5(resp.profile.education[4])
                }
            })
            .catch(err=>{
                console.log(err);
                // window.location.reload();
            })
    },[]);

    // const createNewForm = (name) => {
    //     if(name==="form1"){
    //         setForm2(true)
    //     } else if (name==="form2") {
    //         setForm3(true)
    //     } else if (name==="form3") {
    //         setForm4(true)
    //     } else if (name==="form4") {
    //         setForm5(true)
    //     }
    // }

    // const deleteSomeForm = (name) => {
    //     if(name==="form1"){
    //         setForm1(false)
    //     } else if (name==="form2") {
    //         setForm2(false);
    //     } else if (name==="form3") {
    //         setForm3(false);
    //     } else if (name==="form4") {
    //         setForm4(false);
    //     } else if (name==="form5") {
    //         setForm5(false);
    //     }
    // }

    const handleChange1 = (e) => {
        setDetails1({
            ...details1,
            [e.target.name]: e.target.value
        });
    }
    const handleChange2 = (e) => {
        setDetails2({
            ...details2,
            [e.target.name]: e.target.value
        });
    }
    const handleChange3 = (e) => {
        setDetails3({
            ...details3,
            [e.target.name]: e.target.value
        });
    }
    const handleChange4 = (e) => {
        setDetails4({
            ...details4,
            [e.target.name]: e.target.value
        });
    }
    const handleChange5 = (e) => {
        setDetails5({
            ...details5,
            [e.target.name]: e.target.value
        });
    }

    const submitForm = () => {
        const btn = document.getElementById("save");
        btn.innerHTML=`<img src=${loader} width="20px" />`;
        console.log(userId)
        if(details1.institution===""){
            // can't be
            alert ("Please fill the form to proceed")
        } else if (details2.institution==="") {
            const payload = JSON.stringify({
                info: [details1]
            })
            mainSubmitAction(payload);
        } else if (details3.institution===""){
            const payload = JSON.stringify({
                info: [details1, details2]
            })
            mainSubmitAction(payload);
        } else if (details4.institution==="") {
            const payload = JSON.stringify({
                info: [details1, details2, details3]
            })
            mainSubmitAction(payload);
        } else if (details5.institution==="") {
            const payload = JSON.stringify({
                info: [details1, details2, details3, details4]
            })
            mainSubmitAction(payload);
        } else {
            const payload = JSON.stringify({
                info: [details1, details2, details3, details4, details5]
            })
            mainSubmitAction(payload);
        }
    }

    const mainSubmitAction = (payload) => {
        const btn = document.getElementById("save");
        console.log(payload)

        editEducation(userId, payload)
            .then(res=>res)
            .then(resp=>{
                console.log(resp);
                btn.innerHTML=`Save Changes`;
                toast.success(resp.data.message);
            })
            .catch((err)=>{
                console.log(err);
                btn.innerHTML=`Save Changes`;
            })
    }

    return(
        <div>
            <ToastContainer closeButton={false} />
            <div className="dashboard-content-form-edu" id="formMain" >
                <h3>Education</h3>
                <div>
                    <div>
                        {form1 && 
                            <div className="dashboard-content-form-edu-add">
                                <div className="dashboard-content-form-container">
                                    <label>Name of Institution</label><br/>
                                    <input type="text" name="institution" defaultValue={education1?.institution} onChange={handleChange1} />
                                </div>
                                <div className="dashboard-content-form-container"> 
                                    <label>Course of Study</label><br/>
                                    <input type="text" name="course" defaultValue={education1?.course} onChange={handleChange1} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Qualification</label><br/>
                                    <input type="text" name="qualification" defaultValue={education1?.qualification} onChange={handleChange1} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Start Date</label><br/>
                                    <select name="startMonth" onChange={handleChange1} >
                                        <option value="">{education1?.startMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="startYear" onChange={handleChange1} >
                                        <option value="">{education1?.startYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>End Year</label><br/>
                                    <select name="endMonth" onChange={handleChange1} >
                                        <option value="">{education1?.endMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="endYear" onChange={handleChange1} >
                                        <option value="">{education1?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                {/* <div className="dashboard-content-form-actions">
                                    <div className="dashboard-content-form-actions-delete">
                                        <img src={deleteForm} onClick={()=>deleteSomeForm("form1")} alt="delete"/>
                                    </div>
                                    {!form2 && <img src={addForm} onClick={()=>createNewForm("form1")} alt="add" className="dashboard-content-form-actions-add" />}
                                </div> */}
                            </div>
                        }
                        {form2 && 
                            <div className="dashboard-content-form-edu-add">
                                <div className="dashboard-content-form-container">
                                    <label>Name of Institution</label><br/>
                                    <input type="text" name="institution" defaultValue={education2?.institution} onChange={handleChange2} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Course of Study</label><br/>
                                    <input type="text" name="course" defaultValue={education2?.course} onChange={handleChange2} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Qualification</label><br/>
                                    <input type="text" name="qualification" defaultValue={education2?.qualification} onChange={handleChange2} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Start Year</label><br/>
                                    <select name="startMonth" onChange={handleChange2} >
                                        <option value="">{education2?.startMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="startYear" onChange={handleChange2} >
                                        <option value="">{education2?.startYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>End Year</label><br/>
                                    <select name="endMonth" onChange={handleChange2} >
                                        <option value="">{education2?.endMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="endYear" onChange={handleChange2} >
                                        <option value="">{education2?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                {/* <div className="dashboard-content-form-actions">
                                    {form1 &&
                                        <div className="dashboard-content-form-actions-delete">
                                            <img src={deleteForm} onClick={()=>deleteSomeForm("form2")} alt="delete"/>
                                        </div>
                                    }
                                    {!form3 &&<img src={addForm} onClick={()=>createNewForm("form2")} alt="add" className="dashboard-content-form-actions-add" />}
                                </div> */}
                            </div>
                        }
                        {form3 && 
                            <div className="dashboard-content-form-edu-add">
                                <div className="dashboard-content-form-container">
                                    <label>Name of Institution</label><br/>
                                    <input type="text" name="institution" defaultValue={education3?.institution} onChange={handleChange3} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Course of Study</label><br/>
                                    <input type="text" name="course" defaultValue={education3?.course} onChange={handleChange3} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Qualification</label><br/>
                                    <input type="text" name="qualification" defaultValue={education3?.qualification} onChange={handleChange3} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Start Year</label><br/>
                                    <select name="startMonth" onChange={handleChange3} >
                                        <option value="">{education3?.startMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="startYear" onChange={handleChange3} >
                                        <option value="">{education3?.startYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>End Year</label><br/>
                                    <select name="endMonth" onChange={handleChange3} >
                                        <option value="">{education3?.endMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="endYear" onChange={handleChange3} >
                                        <option value="">{education3?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                {/* <div className="dashboard-content-form-actions">
                                    {form2 &&
                                        <div className="dashboard-content-form-actions-delete">
                                            <img src={deleteForm} onClick={()=>deleteSomeForm("form3")} alt="delete"/>
                                        </div>
                                    }
                                    {!form4 &&<img src={addForm} onClick={()=>createNewForm("form3")} alt="add" className="dashboard-content-form-actions-add" />}
                                </div> */}
                            </div>
                        }
                        {form4 && 
                            <div className="dashboard-content-form-edu-add">
                                <div className="dashboard-content-form-container">
                                    <label>Name of Institution</label><br/>
                                    <input type="text" name="institution" defaultValue={education4?.institution} onChange={handleChange4} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Course of Study</label><br/>
                                    <input type="text" name="course" defaultValue={education4?.course} onChange={handleChange4} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Qualification</label><br/>
                                    <input type="text" name="qualification" defaultValue={education4?.qualification} onChange={handleChange4} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Start Year</label><br/>
                                    <select name="startMonth" onChange={handleChange4} >
                                        <option value="">{education4?.startMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="startYear" onChange={handleChange4} >
                                        <option value="">{education4?.startYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>End Year</label><br/>
                                    <select name="endMonth" onChange={handleChange4} >
                                        <option value="">{education4?.endMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="endYear" onChange={handleChange4} >
                                        <option value="">{education4?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                {/* <div className="dashboard-content-form-actions">
                                    {form3 &&
                                        <div className="dashboard-content-form-actions-delete">
                                            <img src={deleteForm} onClick={()=>deleteSomeForm("form4")} alt="delete"/>
                                        </div>
                                    }
                                    {!form5 &&<img src={addForm} onClick={()=>createNewForm("form4")} alt="add" className="dashboard-content-form-actions-add" />}
                                </div> */}
                            </div>
                        }
                        {form5 && 
                            <div className="dashboard-content-form-edu-add">
                                <div className="dashboard-content-form-container">
                                    <label>Name of Institution</label><br/>
                                    <input type="text" name="institution" defaultValue={education5?.institution} onChange={handleChange5} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Course of Study</label><br/>
                                    <input type="text" name="course" defaultValue={education5?.course} onChange={handleChange5} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Qualification</label><br/>
                                    <input type="text" name="qualification" defaultValue={education5?.qualification} onChange={handleChange5} />
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>Start Year</label><br/>
                                    <select name="startMonth" onChange={handleChange5} >
                                        <option value="">{education5?.startMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="startYear" onChange={handleChange5} >
                                        <option value="">{education5?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                <div className="dashboard-content-form-container">
                                    <label>End Year</label><br/>
                                    <select name="endMonth" onChange={handleChange5} >
                                        <option value="">{education5?.endMonth}</option>
                                        <option value="Jan">January</option>
                                        <option value="Feb">February</option>
                                        <option value="Mar">March</option>
                                        <option value="Apr">April</option>
                                        <option value="May">May</option>
                                        <option value="Jun">June</option>
                                        <option value="Jul">July</option>
                                        <option value="Aug">August</option>
                                        <option value="Sep">September</option>
                                        <option value="Oct">October</option>
                                        <option value="Nov">November</option>
                                        <option value="Dec">December</option>
                                    </select>
                                    <select name="endYear" onChange={handleChange5} >
                                        <option value="">{education5?.endYear}</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                    </select>
                                </div>
                                {/* <div className="dashboard-content-form-actions">
                                    <div className="dashboard-content-form-actions-delete">
                                        <img src={deleteForm} onClick={()=>deleteSomeForm("form5")} alt="delete"/>
                                    </div>
                                    <img src={addForm} onClick={()=>createNewForm("form5")} alt="add" className="dashboard-content-form-actions-add" />
                                </div> */}
                            </div>
                        }
                        <div className="dashboard-content-form-edu-submit" >
                            <button onClick={submitForm} id="save">Save Changes</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}


export default Education;